import styled, { css } from "styled-components";
import { Colors } from "@batmaid/design-tokens";

import { Link } from "@components/Navigation/Link";

import { transition } from "@ui/helpers";
import { Arrow } from "@ui/Assets/MyIcons";

import { RootProps } from "./Dropdown.types";
import { setPosition } from "./Dropdown.helpers";

export const Root = styled.div`
  position: relative;
  width: fit-content;
`;

export const Button = styled(Link).attrs({ as: "button", type: "button" })<{
  $hoverColor?: keyof Colors;
}>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: ${props => props.theme.spacing.spacing_8};
  z-index: 1;

  ${props =>
    props.$hoverColor &&
    css`
      &:hover {
        ${props => props.theme.breakpointsV2.smallTablet} {
          color: ${props.theme.palette[props.$hoverColor]};
        }
      }
    `}
`;

export const Label = styled.span<{ $ellipsis?: boolean }>`
  ${props =>
    props.$ellipsis &&
    css`
      flex: 0 1 auto;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}
`;

export const ArrowIcon = styled(Arrow)<{ $isActive?: boolean }>`
  flex: 0 0;
  transform: rotate(90deg);
  transition: ${transition(["transform"])};
  pointer-events: none;

  ${props => props.theme.breakpointsV2.smallDesktop} {
    min-width: 24px;
    min-height: 24px;
  }

  ${props =>
    props.$isActive &&
    css`
      transform: rotate(-90deg);
    `}
`;

export const Panel = styled.div<RootProps>`
  --dropdown-shift: ${props => props.theme.spacing.spacing_24};

  position: absolute;
  top: calc(100% + ${props => props.$distance}px);
  right: 0;

  ${props => setPosition(props.$position)}

  width: 229px;
  padding: ${props => props.theme.spacing.spacing_24};
  border-radius: 0 0 12px 12px;
  background-color: ${props => props.theme.palette.white};
  opacity: 0;
  transform: translateY(calc(var(--dropdown-shift) * -1));
  transition: ${transition(["opacity", "transform"])};
  pointer-events: none;
  /* filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.1)); */ // maybe someday

  ${props =>
    props.$zIndex &&
    css`
      z-index: ${props.$zIndex};
    `}

  ${props =>
    props.$isActive &&
    css`
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    `}

  ${props => props.theme.breakpointsV2.smallDesktop} {
    width: 263px;
    padding: ${props => props.theme.spacing.spacing_32};
  }
`;
